const isPrerender = () => {
  return navigator.userAgent.toLowerCase().indexOf('prerender') >= 0
}

export default isPrerender
